/* 司馬懿傳・第 1 章：新城・上庸（227–228 年）
 * 東邊是宛（司馬懿屯兵的地方），一條大路往西一千二百里到上庸。上庸「三面阻水」：北、西、南三面被堵水繞著，
 * 只有東面是陸地，孟達在城外立了一道木柵。半路有兩條岔路：北邊往木闌塞（蜀軍來救），南邊往西城安橋（吳軍來救）。 */
export const CITY = { x: 1900, y: 2300, hw: 460, hh: 380 };
const T = 36, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const WAN = [9000, 2300], GATE = [E, CITY.y], FENCE_X = 3000, FENCE = [-4, -3, -2, -1, 0, 1, 2, 3, 4].map((k) => [FENCE_X, CITY.y + k * 255]);
export const FORKS = [{ id: 'mulan', name: '木闌塞', at: [5200, 2300], to: [5200, 650], who: '蜀' }, { id: 'anqiao', name: '安橋', at: [4100, 2300], to: [4100, 3950], who: '吳' }];
export default {
  id: 'simayi_xincheng', name: '新城上庸', W: 9800, H: 4400, seed: 2271,
  bases: [WAN, [CITY.x, CITY.y]],
  walls: [[CITY.x, N, CITY.hw + T, T], [CITY.x, S, CITY.hw + T, T], [Wx, CITY.y, T, CITY.hh], [E, (N + CITY.y - 130) / 2, T, (CITY.y - 130 - N) / 2], [E, (S + CITY.y + 130) / 2, T, (S - CITY.y - 130) / 2]],
  // 堵水：北、西、南三面繞著上庸，開口朝東
  rivers: [{ pts: [[3300, 1000], [2000, 1050], [900, 1400], [700, 2300], [900, 3200], [2000, 3550], [3300, 3600]], hw: 150, fords: [] }],
  roads: [
    { pts: [WAN, [7600, 2200], [6200, 2380], FORKS[0].at, FORKS[1].at, [FENCE_X + 300, CITY.y], GATE, [CITY.x, CITY.y]], w: 150 },
    { pts: [FORKS[0].at, [5300, 1500], FORKS[0].to], w: 100 },
    { pts: [FORKS[1].at, [4000, 3200], FORKS[1].to], w: 100 },
  ],
  rocks: [[7000, 1100, 500, 260], [6800, 3500, 520, 260], [3300, 700, 260, 200], [3300, 3900, 260, 200], [8300, 3500, 300, 180]],
  woods: 0.5,
  sight: 0.9,
  clearings: [[WAN[0], WAN[1], 600], [CITY.x, CITY.y, 1150], [FENCE_X + 300, CITY.y, 600], [FORKS[0].to[0], FORKS[0].to[1], 300], [FORKS[1].to[0], FORKS[1].to[1], 300]],
  villages: [{ x: CITY.x, y: CITY.y, n: 7, r: 300 }],
  tents: [{ x: WAN[0], y: WAN[1], n: 6, r: 420, chief: true, col: '#3b5a99', flag: '司馬' }, { x: FORKS[0].to[0], y: FORKS[0].to[1], n: 2, r: 200, col: '#4a6a3a', flag: '蜀' }, { x: FORKS[1].to[0], y: FORKS[1].to[1], n: 2, r: 200, col: '#7a3a2a', flag: '吳' }],
  fields: [[8200, 1600, 500, 240], [6000, 3000, 520, 240, '#86803f']],
  grass: [[4600, 1900, 220, 100], [6600, 2700, 240, 100]],
};
